import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { isObject } from '@slardar/sdk-template';
import { getLocationUrl } from '../../utils';
export function getPluginConfig(client, pluginName, defaultConfig) {
    var _a;
    var c = (_a = client.config()) === null || _a === void 0 ? void 0 : _a.plugins[pluginName];
    if (isObject(c)) {
        return __assign(__assign({}, defaultConfig), c);
    }
    else {
        return c ? defaultConfig : false;
    }
}
export var reportOnInitCommonParams = function (client, overrides) {
    var clientConfig = client.config();
    var common = {
        url: getLocationUrl(),
        pid: clientConfig.pid,
        view_id: clientConfig.viewId,
    };
    return function (ev) {
        client.report(__assign(__assign({}, ev), { overrides: __assign(__assign({}, common), ((overrides && overrides(ev)) || {})) }));
    };
};
//# sourceMappingURL=utils.js.map